// Manifest of bundled MIDI clips available in the player dropdown.
//
// Adding a clip is two steps:
//   1. Drop the `.mid` file in `web/public/midi/`.
//   2. Add a `{ name, url }` entry to the array below. `url` is the path
//      under `public/`, so `/midi/foo.mid` for `web/public/midi/foo.mid`.
//
// The player widget filters out entries whose file fails to fetch at runtime,
// so a typo here is recoverable — it just won't appear in the dropdown.

export interface MidiClipEntry {
  /** Display name in the dropdown — keep it short. */
  name: string;
  /** Absolute URL under the deployed site root. */
  url: string;
}

export const BUNDLED_MIDI_CLIPS: MidiClipEntry[] = [
  { name: "Levels", url: "/midi/Levels.mid" },
  { name: "Hey Brother", url: "/midi/Hey%20Brother.mid" },
  { name: "I Could Be The One", url: "/midi/I%20Could%20Be%20The%20One.mid" },
  { name: "The Veldt", url: "/midi/The%20Veldt.mid" },
  { name: "Trix", url: "/midi/Trix.mid" },
];
